import React, { useEffect, useState } from "react";

import { getLoginInfo, setSearchInfo } from '../../../shared/utils/storage';
import { useNavigate } from "react-router-dom";
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import { createNotification } from '../../../shared/components/Popup';
import { generatePDF } from "../../../shared/services/listReport";
import { Button } from "react-bootstrap";
import { exportToExcel } from "../../../shared/hooks/useExportToExcel";

function ReportTableComponent({ userData, reportType }) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [userName, setUserName] = useState();
  const [loading, setLoading] = useState([]);
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [applications, setApplications] = useState([]);
  const [pdfBase64, setPdfBase64] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    if (userData?.PoolList) {
      setData(userData.PoolList);
      setCurrentPage(1);
    }
  }, [userData]);

  // Reset to page 1 when search changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredData = Array.isArray(data)
    ? data.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    : [];

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const viewApplicationsDetails = async (applicationID, index) => {
    const newLoading = [...loading];
    newLoading[index] = true;
    setLoading(newLoading);

    const payload = {
      ApplicationId: applicationID,
      UserName: getLoginInfo()?.user?.Username,
      StageId: "",
      Station: getLoginInfo()?.user?.StationID,
      Action: "View",
      AccessorId: getLoginInfo()?.user?.UserID,
    };

    try {
      const result = await handleApplicationManagement(
        payload,
        "application_management",
      );

      newLoading[index] = false;
      setLoading(newLoading);

      if (result?.code == 1) {
        const response = {
          data: result.data,
          pageFrom: "Report",
        };
        setSearchInfo(response);
        navigate("/viewSearchedDetails");
      } else {
        setApplications(null);
        const info = { type: "error", message: result?.message };
        createNotification(info)();
      }
    } catch (error) {
      console.error("Error handling application:", error);

      // Ensure loading is set to false in case of an error
      newLoading[index] = false;
      setLoading(newLoading);
    }
  };

  const pdfGenerationManager = async () => {
    const newData = await generatePDF(userData, reportType);
  };

  const excelGenerationManager = async () => {
    exportToExcel(userData?.PoolList, reportType);
  };

  const styles = {
    loadingContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    loadingImage: {
      width: "70px",
      height: "70px",
    },
    td: {
      textAlign: "center",
    },
  };
  return (
    <>
      <div className="row">
        <div className="container">
          {/* Toolbar: export buttons + search */}
          <div className="row" style={{ marginBottom: "12px", alignItems: "center" }}>
            <div className="col-md-4">
              <Button
                variant="outlined"
                className="btn-primary btn-sm"
                onClick={() => excelGenerationManager()}
              >
                Excell
              </Button>
              <Button
                variant="outlined"
                className="btn-primary btn-sm"
                onClick={() => pdfGenerationManager()}
              >
                PDF
              </Button>
            </div>
            <div className="col-md-4"></div>
            <div className="col-md-4" style={{ textAlign: "right" }}>
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  padding: "6px 10px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  width: "100%",
                  maxWidth: "260px",
                }}
              />
            </div>
          </div>
          <table className="table" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th style={styles.td}>S/no.</th>
                <th style={styles.td}>Control Number</th>
                <th style={styles.td}>Fullname</th>
                {reportType.ReportType === "issued_etd_reports"||reportType.ReportType === "get_etd_reports_by_admin" && (
                  <th style={styles.td}>ETD Number</th>
                )}
                {reportType.ReportType === "issued_etd_reports"||reportType.ReportType === "get_etd_reports_by_admin" && (
                  <th style={styles.td}>Station</th>
                )}
                {/* {reportType.ReportType === "issued_etd_reports"||reportType.ReportType === "get_etd_reports_by_admin" && (
                  <th style={styles.td}>Issued Date</th>
                )} */}

                {reportType.ReportType === "get_etd_reports_by_doctype" && (
                  <th style={styles.td}>ETD Number</th>
                )}
                {reportType.ReportType === "get_etd_reports_by_doctype" && (
                  <th style={styles.td}>Station</th>
                )}
                {reportType.ReportType === "get_etd_reports_by_doctype" && (
                  <th style={styles.td}>Issued Date</th>
                )}

                {reportType.ReportType === "payments_report" && (
                  <th style={styles.td}>Amount</th>
                )}
                {reportType.ReportType === "payments_report" && (
                  <th style={styles.td}>Paid Date</th>
                )}

                {/* <th>Expired Date</th> */}

                <th style={styles.td}>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((user, i) => (
                  <tr key={(currentPage - 1) * itemsPerPage + i}>
                    <td style={styles.td}>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                    <td style={styles.td}>{user?.PaymentControlNo}</td>
                    <td style={styles.td}>{user?.FullName}</td>
                    {reportType.ReportType === "issued_etd_reports" ||reportType.ReportType === "get_etd_reports_by_admin" && (
                      <td style={styles.td}>{user?.ETDNumber}</td>
                    )}
                    {/* {reportType.ReportType === "issued_etd_reports" ||reportType.ReportType === "get_etd_reports_by_admin" && (
                      <td style={styles.td}>{user?.IssuedAt}</td>
                    )} */}
                    {reportType.ReportType === "issued_etd_reports" ||reportType.ReportType === "get_etd_reports_by_admin" && (
                      <td style={styles.td}>{user?.IssuedDate}</td>
                    )}

                    {reportType.ReportType === "get_etd_reports_by_doctype" && (
                      <td style={styles.td}>{user?.ETDNumber}</td>
                    )}
                    {reportType.ReportType === "get_etd_reports_by_doctype" && (
                      <td style={styles.td}>{user?.IssuedAt}</td>
                    )}
                    {reportType.ReportType === "get_etd_reports_by_doctype" && (
                      <td style={styles.td}>{user?.IssuedDate}</td>
                    )}

                    {reportType.ReportType === "payments_report" && (
                      <td style={styles.td}>{user?.Amount}</td>
                    )}
                    {reportType.ReportType === "payments_report" && (
                      <td style={styles.td}>{user?.ReceiptDate}</td>
                    )}
                    {/* <td>{user?.ExpiredDate}</td> */}

                    <td style={styles.td}>
                      <Button
                        className="btn-primary btn-sm"
                        onClick={() =>
                          viewApplicationsDetails(user?.ApplicationID, i)
                        }
                      >
                        <i className="fa fa-eye"></i> | View
                      </Button>
                      {/* <button
                                                className="btn-primary"
                                                onClick={() => viewApplicationsDetails(user?.ApplicationID, i)}
                                            >
                                                <i className="fa fa-eye"></i> | View
                                            </button> */}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {/* Pagination controls */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "12px",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            <div style={{ fontSize: "14px", color: "#555" }}>
              {filteredData.length === 0
                ? "No records"
                : `Showing ${(currentPage - 1) * itemsPerPage + 1}–${Math.min(
                    currentPage * itemsPerPage,
                    filteredData.length
                  )} of ${filteredData.length} records`}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{
                  padding: "4px 8px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              >
                {[10, 25, 50, 100].map((n) => (
                  <option key={n} value={n}>
                    {n} / page
                  </option>
                ))}
              </select>
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                style={paginationBtnStyle(currentPage === 1)}
              >
                «
              </button>
              <button
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
                style={paginationBtnStyle(currentPage === 1)}
              >
                ‹
              </button>
              {Array.from({ length: totalPages }, (_, idx) => idx + 1)
                .filter(
                  (p) =>
                    p === 1 ||
                    p === totalPages ||
                    Math.abs(p - currentPage) <= 1
                )
                .reduce((acc, p, idx, arr) => {
                  if (idx > 0 && p - arr[idx - 1] > 1) {
                    acc.push("...");
                  }
                  acc.push(p);
                  return acc;
                }, [])
                .map((item, idx) =>
                  item === "..." ? (
                    <span key={`ellipsis-${idx}`} style={{ padding: "0 4px" }}>
                      …
                    </span>
                  ) : (
                    <button
                      key={item}
                      onClick={() => setCurrentPage(item)}
                      style={paginationBtnStyle(false, item === currentPage)}
                    >
                      {item}
                    </button>
                  )
                )}
              <button
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
                disabled={currentPage === totalPages || totalPages === 0}
                style={paginationBtnStyle(
                  currentPage === totalPages || totalPages === 0
                )}
              >
                ›
              </button>
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages || totalPages === 0}
                style={paginationBtnStyle(
                  currentPage === totalPages || totalPages === 0
                )}
              >
                »
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="row2">
                <div className="card2">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-1"></div>
                            <div className="col-md-10">
                                <embed
                                    src={pdfBase64}
                                    className="myEmbed"
                                    type="application/pdf"
                                    width="100%"
                                    height="1200px"
                                />
                            </div>
                            <div className="col-md-1"></div>
                        </div>
                    </div>
                </div>

            </div> */}
    </>
  );
}

export default ReportTableComponent;

function paginationBtnStyle(disabled, active = false) {
  return {
    padding: "4px 10px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    cursor: disabled ? "not-allowed" : "pointer",
    background: active ? "#1976d2" : disabled ? "#f5f5f5" : "#fff",
    color: active ? "#fff" : disabled ? "#bbb" : "#333",
    fontWeight: active ? "bold" : "normal",
  };
}
